export default __webpack_public_path__ + "static/media/tab_shape_bg.57723bdf.png";